export const STATUS = {
  successCode: '0',
  errorCode: '1',
}
